import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const aboutUsFunSections = document.querySelectorAll('.js-section-about-us-fun-block');

    aboutUsFunSections.forEach((section) => {
        function initSwiper() {
            const imageContainer = section.querySelector('.js-section-about-us-fun-block-image');
            const slides = imageContainer.querySelectorAll('.section-about-us-fun-block__image');

            if (window.innerWidth < 992) {
                // Add swiper-slide class if Swiper is being initialized
                slides.forEach(slide => slide.classList.add('swiper-slide'));

                if (!imageContainer.swiper) {
                    new Swiper(imageContainer, {
                        modules: [Autoplay, Pagination],
                        loop: false,
                        autoplay: {
                            delay: 6000,
                        },
                        slidesPerView: 2,
                        spaceBetween: 10,
                        pagination: {
                            el: section.querySelector('.swiper-pagination'),
                            clickable: true,
                        },
                        breakpoints: {
                            992: {
                                slidesPerView: 4,
                            }
                        }
                    });
                }
            } else {
                // Remove swiper-slide class if Swiper is being destroyed
                slides.forEach(slide => slide.classList.remove('swiper-slide'));

                const swiperInstance = imageContainer.swiper;
                if (swiperInstance) {
                    swiperInstance.destroy(true, true);
                }
            }
        }

        initSwiper();
        window.addEventListener('resize', initSwiper);
    });
});